module.exports = __webpack_public_path__ + "static/media/clarinet.72fe7df0.svg";